// ImpersonationBanner.jsx
import React from 'react';
import Api from './Api';

const ImpersonationBanner = () => {
    const { http } = Api();

    const stopImpersonation = () => {
        http.post('/stopimpersonation')
            .then((response) => {
                localStorage.removeItem('impersonating');
                localStorage.removeItem('token');
                localStorage.clear();

            
                // Set admin token and data
                if (response.data.admin_token) {
                    localStorage.setItem('token', response.data.admin_token);

                    // Set admin user data
                    if (response.data.admin_user) {
                        localStorage.setItem('username', response.data.admin_user.name);
                        localStorage.setItem('usertype', response.data.admin_user.user_type);
                        localStorage.setItem('id', response.data.admin_user.id);
                        if (response.data.admin_user.college_id) {
                            localStorage.setItem('collegeid', response.data.admin_user.college_id);
                        }
                    }

                    // Redirect to admin dashboard
                    window.location.href = '/#/admin/dashboard';
                } else {
                    // Fallback: clear everything and redirect to login
                    localStorage.clear();
                    window.location.href = '/';
                }
            })
            .catch(error => {
                console.error('Stop impersonation failed:', error);
                // Fallback: clear everything and redirect to login
                localStorage.clear();
                window.location.href = '/';
            });


    };

    if (!localStorage.getItem('impersonating')) {
        return null;
    }

    return (
        <div style={{
            backgroundColor: '#ff9800',
            color: 'white',
            padding: '10px',
            textAlign: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000
        }}>
            <strong>⚠️ ADMIN IMPERSONATION MODE ⚠️</strong>
            <button
                onClick={stopImpersonation}
                style={{
                    marginLeft: '20px',
                    backgroundColor: 'red',
                    color: 'white',
                    border: 'none',
                    padding: '5px 10px',
                    cursor: 'pointer'
                }}
            >
                Stop Impersonation
            </button>
        </div>
    );
};

export default ImpersonationBanner;